// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTESTS_I_WANT_TO_RECEIVE_notifications = "Chcem dost\u00e1va\u0165 %(notifications)s na nov\u00e9 s\u00fa\u0165a\u017ee";
export const CONTESTS_WITH_AMBASSADORS = "S\u00fa\u0165a\u017e\u00edme s ambas\u00e1dorkami";
export const CONTESTS_WITH_MK = "S\u00fa\u0165a\u017e\u00edme s kon\u00edkom";
export const NOTIFICATIONS = "Upozornenia";
export const TOPIC_CONTESTS_ENDED_TITLE = "Ukon\u010den\u00e9 s\u00fa\u0165a\u017ee";
export const TOPIC_CONTESTS_NO_RUNNING = "Moment\u00e1lne neprebieha \u017eiadna s\u00fa\u0165a\u017e. Sk\u00fas pr\u00eds\u0165 nesk\u00f4r, s\u00fa\u0165a\u017e\u00ed sa \u010dasto.";
